import React from 'react';

function DisclaimerBox({ mode, setShareModalOpen, gunId }) {
  // ---------------------------------------------------------
  // MOBILE LAYOUT (Appears at the bottom of the left column)
  // ---------------------------------------------------------
  if (mode === "mobile") {
    return (
      <div className="mobile-only-content" style={{ marginTop: "30px", marginBottom: "20px" }}>
          <div style={{ padding: "15px", backgroundColor: "#1a1a1a", borderLeft: "3px solid #D5A678", borderRadius: "4px", marginBottom: "20px" }}>
              <strong style={{ color: "#fff", display: "block", marginBottom: "8px", textTransform: "uppercase", fontSize: "13px" }}>Important Notes:</strong>
              <ul style={{ paddingLeft: "20px", margin: 0, fontSize: "12px", lineHeight: "1.7", color: "#aaa" }}>
                  <li><strong>Threadlocker:</strong> We highly recommend applying a non-permanent threadlocker (like Loctite Blue 242) to all hardware once you have your retention dialed in.</li>
                  <li style={{ color: "#fff", fontWeight: "bold" }}><strong>Visualizer:</strong> This visualizer is a representation and not an exact photo of the final product; size may vary depending on light and model.</li>
                  <li style={{ color: "#fff", fontWeight: "bold" }}><strong>Fitment:</strong> Non-OEM parts can impact fitment, to verify compatibility please <a href="https://www.anrkydexholsters.com/contact/" target="_blank" rel="noopener noreferrer" style={{ color: "#D5A678", textDecoration: "underline", fontWeight: "bold" }}>contact our customer service team</a>.</li>
                  <li>*Sezzle payment option available at checkout for orders over $150.</li>
              </ul>
          </div>
          <button 
              className="share-build-btn" 
              onClick={() => setShareModalOpen(true)} 
              disabled={!gunId}
              style={{ width: "100%", padding: "15px", fontSize: "14px" }}
          >
              Save & Share Build
          </button>
      </div>
    );
  }

  // ---------------------------------------------------------
  // DESKTOP LAYOUT (Appears under the right-side visualizer)
  // ---------------------------------------------------------
  return (
    <div className="desktop-only-content">
        <div style={{ marginTop: "12px", borderTop: "1px solid #444", paddingTop: "10px", marginBottom: "15px" }}>
            <div style={{ fontSize: "11px", color: "#bbb", fontWeight: "400", letterSpacing: "0.5px", lineHeight: "1.6", marginBottom: "8px" }}>
              *Sezzle payment option available at checkout for orders over $150.
            </div>
            <div style={{ fontSize: "12px", color: "#fff", fontWeight: "bold", lineHeight: "1.5", letterSpacing: "0.3px", marginBottom: "8px" }}>
              Note: This visualizer is designed to give a general idea of your build. It is a representation and not an exact photo of the final product, size may vary depending on light and model chosen.
            </div>
            <div style={{ fontSize: "12px", color: "#fff", fontWeight: "bold", lineHeight: "1.5", letterSpacing: "0.3px", marginBottom: "8px" }}>
              Non-OEM parts can impact fitment, to verify compatibility please <a href="https://www.anrkydexholsters.com/contact/" target="_blank" rel="noopener noreferrer" style={{ color: "#D5A678", textDecoration: "underline", fontWeight: "bold" }}>contact our customer service team</a>.
            </div>
            <div style={{ fontSize: "10px", color: "#888", fontStyle: "italic", lineHeight: "1.4", letterSpacing: "0.3px" }}>
              Threadlocker: We highly recommend applying a non-permanent threadlocker (like Loctite Blue 242) to all hardware once retention is dialed in.
            </div>
        </div>
        
        <button className="share-build-btn" onClick={() => setShareModalOpen(true)} disabled={!gunId}>
          Save & Share Build
        </button>
    </div>
  );
}

export default DisclaimerBox;